<template>
  <flash-message></flash-message>
  <transition name="vslide">
    <header v-if="$store.state.showHeader">
      <site-header @openHelp="openHelp" />
    </header>
    <div
      v-else
      class="md:hidden flex flex-row justify-end w-full print:hidden">
      <button
        @click.prevent="$store.commit('toggleMobileMenu')"
        class="text-black block md:hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>
  </transition>
  <site-nav
    v-if="$store.state.showNav"
    id="main-site-nav"
    class="print:hidden"
    @openHelp="openHelp" />
  <router-view v-slot="{ Component, route }">
    <transition
      name="fade"
      mode="out-in">
      <component
        :is="Component"
        :key="route.path" />
    </transition>
  </router-view>
  <site-footer id="main-site-footer" />
  <confirm-dialogue
    ref="helpWrapper"
    extra-button-text="Frequently Asked Questions"
    @extra="$router.push({ name: 'FAQ' })">
    <site-help />
  </confirm-dialogue>
</template>

<script>
import FlashMessage from "@/components/utilities/FlashMessage";
import SiteHeader from "@/components/SiteHeader";
import SiteNav from "@/components/navigation/SiteNav";
import SiteFooter from "@/components/SiteFooter";
import ConfirmDialogue from "@/components/utilities/ConfirmDialogue.vue";
import SiteHelp from "@/components/SiteHelp.vue";

export default {
  name: "App",
  components: {
    FlashMessage,
    SiteNav,
    SiteHeader,
    SiteFooter,
    ConfirmDialogue,
    SiteHelp
  },
  methods: {
    openHelp() {
      this.$refs.helpWrapper
        .show({
          title: undefined,
          message: undefined,
          okButton: "Close Help",
          hideCancelButton: true,
          largeWindow: true
        })
        .then(() => {})
        .catch(() => {});
    }
  }
};
</script>

<style>
body {
  overflow-y: scroll;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.fade-enter-active {
  transition: all 100ms ease;
}

.fade-leave-active {
  transition: all 100ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slow-fade-enter-active {
  transition: all 300ms ease;
}

.slow-fade-leave-active {
  transition: all 300ms ease;
}

.slow-fade-enter-from,
.slow-fade-leave-to {
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.quick-fade-enter-active {
  transition: all 50ms ease;
}

.quick-fade-leave-active {
  transition: all 50ms ease;
}

.quick-fade-enter-from,
.quick-fade-leave-to {
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.vslide-enter-active {
  transition: all 300ms ease-in-out;
}

.vslide-leave-active {
  transition: all 300ms ease-in-out;
}

.vslide-enter-from,
.vslide-leave-to {
  transform: translateY(-100%);
}
</style>
